/** List URL for user dialogue categories, optionally restoring a selected category. */
export function dialogueCategoriesListPath(categoryId?: number | null): string {
  if (categoryId != null && Number.isFinite(categoryId) && categoryId > 0) {
    return `/material/dialogue-categories?category=${categoryId}`;
  }
  return '/material/dialogue-categories';
}

export function parseCategoryQueryId(value: string | null | undefined): number | null {
  if (value == null || value === '') return null;
  const n = Number(value);
  return Number.isInteger(n) && n > 0 ? n : null;
}
